import { createContext, useContext } from 'react';

/**
 * The sticky header's ref, published so the hero's scroll effect can
 * measure its height without reaching across the tree with a querySelector.
 */
export const HeaderHeightContext = createContext(null);

export const useHeaderRef = () => useContext(HeaderHeightContext);
